import React from 'react';
import { Navigator } from './comps';
import { ContentBody } from 'areas/shared/components';
import * as Notifications from 'fw/globals/Notifications';
import * as Steps from './steps';
import * as API from 'modules/app/API';
import * as FormManager from 'fw/forms/form/FormManager';
import * as Modals from 'fw/globals/Modals'

const steps = {
    CI: Steps.CompanyInfo,
    VI: Steps.VeteranOwnerInfo,
    BS: Steps.BusinessStructure,
    CER: Steps.BusinessCertifications,
    FIN: Steps.FinancialDocuments,
    BNK: Steps.BankInfo,
    TAX: Steps.TaxInfo,
    EQ: Steps.EquipmentInfo,
    ART: Steps.Articles,
    DEC: Steps.Declaration
};

const stepCI = 'CI';
const stepDEC = 'DEC';
const stepFIN = 'FIN';

const fastTrackText = "Congratulations! You are eligible for the VOCS Fast Track.<br /><br />" +
    "Please ensure that you Print and Completed the VOCS Declaration before Submitting your Application."

class Certification extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
        this._stepRef = null;
    }

    validateForm() {
        return null;
    }

    initialState = () => {
        return {
            certificationSteps: null,
            stepInfo: null,
            stepData: null,
            stepTooltip: null,
            postData: null
        };
    };

    handleStepCancel = () => {
        const me = this;
        FormManager.checkUnsavedChanges(function () {
            me.props.history.push('/');
        });
    };

    handleStepNavigation = (targetStepCode, validate) => {
        this.saveStep(validate, {
            success: r => {
                if (r.data.fastTrack !== this.state.stepInfo.fastTrack) {
                    var nextStep = targetStepCode;
                    if (r.data.fastTrack) {
                        if (targetStepCode === stepFIN)
                            nextStep = stepDEC;
                        Modals.info("Fast Track Approved", fastTrackText, () => {
                            this.setState(prevState => {
                                return {
                                    stepInfo: Object.assign(prevState.stepInfo, {
                                        fastTrack: r.data.fastTrack,
                                        ownersUpdatedFlagged: r.data.ownersUpdatedFlagged,
                                    })
                                };
                            }, this.navigate(nextStep))
                        });
                    }
                    else {
                        if (targetStepCode === stepDEC)
                            nextStep = stepFIN;
                        
                        this.setState(prevState => {
                            return {
                                stepInfo: Object.assign(prevState.stepInfo, {
                                    ownersUpdatedFlagged: r.data.ownersUpdatedFlagged,
                                })
                            };
                        }, this.navigate(nextStep))
                    }
                }
                else
                {
                    this.setState(prevState => {
                        return {
                            stepInfo: Object.assign(prevState.stepInfo, {
                                ownersUpdatedFlagged: r.data.ownersUpdatedFlagged,
                            })
                        };
                    }, this.navigate(targetStepCode))
                }
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    };

    handleStepSave = () => {
        this.saveStep(true, {
            success: r => {
                var nextStep = this.state.stepInfo.nextStepCode;

                if (r.data.fastTrack !== this.state.stepInfo.fastTrack)
                {
                    if (r.data.fastTrack) {
                        if (this.state.stepInfo.nextStepCode === stepFIN)
                            nextStep = stepDEC;

                        Modals.info("Fast Track Approved", fastTrackText);
                    }
                    else
                        nextStep = stepFIN;
                }

                // Update Row Version
                this.setState(prevState => {
                    return {
                        postData: Object.assign(prevState.postData, {
                            rowVersion: r.data.rowVersion,
                            entityId: r.data.entityId
                        }),
                        stepInfo: Object.assign(prevState.stepInfo, {
                            fastTrack: r.data.fastTrack,
                            ownersUpdatedFlagged: r.data.ownersUpdatedFlagged,
                            nextStepCode: nextStep,
                        })
                    };
                });

                FormManager.reset();

                this.getCertificationSteps();
                Notifications.success(r.message);
            },
            error: e => {
                Notifications.error(e.error.errorMessage);
            }
        });
    };

    handleStepChange = postData => {
        this.setState({
            postData
        });
    };

    getCertificationSteps = () => {
        var rq = {
            certificationKey: this.props.match.params.certificationKey
        };

        API.Certification.get(
            '/certificationSetup/getCertificationSteps',
            rq,
            {
                success: r => {
                    this.setState({
                        certificationSteps: r.data.certificationSteps
                    });
                }
            },
            { block: false }
        );
    };

    getStep = stepCode => {
        var rq = {
            certificationKey: this.props.match.params.certificationKey,
            stepCode: stepCode
        };
        API.Certification.get(
            '/certificationSetup/getStep',
            rq,
            {
                success: r => {
                    this.setState({
                        stepInfo: r.data.stepInfo,
                        stepData: r.data.stepData,
                        stepTooltip: r.data.stepTooltip,
                        postData: r.data.stepData
                    });
                },
                error: r => {
                    Notifications.error(r.error.errorMessage);
                }
            },
            { block: true }
        );
    };

    handleSubmit = () => {
        const submitText = "Thank you for Submitting your VOCS-Sponsored Application.<br /><br />" +
            "Your Completed Application has been recorded within the VOCS Database.<br /><br />" +
            "Your Application will be reviewed, and you will be notified via Email after the Application has been reveiwed by the VOCS Team.<br /><br />" +
            "A member of VOCS may contact you with any questions they may have regarding your Certification Application.<br /><br />" +
            "If you have any questions regarding your Application, please don't hesitate to email us at VOCS Certification: <a href='mailto:certification@nvbdc.org'>certification@nvbdc.org</a><br /><br />";

        // Prepare request
        var rq = {
            certificationKey: this.props.match.params.certificationKey,
            declarationStorageToken: this.state.postData.declarationStorageToken,
            declarationFileName: this.state.postData.declarationFileName,
            rowVersion: this.state.postData.rowVersion
        };

        // Post!
        API.Certification.post('/certificationSetup/submitCertification', rq,
            {
                success: (r) => {
                    Modals.info("Application Completed!", submitText, () => {
                        window.location.href = "/";
                    });
                },
                error: r => {
                    Notifications.error(r.error.errorMessage);
                }
            });
    };

    saveStep = (validate, callbacks) => {
        // Prepare request
        var rq = {
            certificationKey: this.props.match.params.certificationKey,
            stepCode: this.state.stepInfo.stepCode,
            stepData: this.state.postData,
            validate: validate
        };

        // Post!
        API.Certification.post('/certificationSetup/saveStep', rq, callbacks);
    };

    navigate(targetStepCode) {
        this.props.history.push('/certification/certification/' + targetStepCode + '/' + this.props.match.params.certificationKey);
    }

    componentWillMount() {
        var stepCode = stepCI;

        if (this.props.match.params.stepCode !== undefined) stepCode = this.props.match.params.stepCode.toUpperCase();

        this.getCertificationSteps();
        this.getStep(stepCode);
    }

    componentWillReceiveProps({ match }) {
        if (this.state.stepInfo === null)
            return;
            
        var currentStepCode = this.state.stepInfo.stepCode.toUpperCase();
        var targetStepCode = match.params.stepCode.toUpperCase();

        if (currentStepCode !== targetStepCode) {
            this.getCertificationSteps();
            this.getStep(targetStepCode);
        }
    }

    render() {
        if (this.state.stepInfo === null || this.state.certificationSteps === null) return null;

        const stepInfo = this.state.stepInfo;
        const Step = steps[stepInfo.stepCode];

        return (
            <React.Fragment>
                <ContentBody>
                    <Navigator
                        certificationSteps={this.state.certificationSteps}
                        certificationKey={this.props.match.params.certificationKey}
                        currentStepInfo={stepInfo}
                        onStepNavigation={this.handleStepNavigation}
                        onStepSave={this.handleStepSave}
                        onStepCancel={this.handleStepCancel}
                        onSubmit={this.handleSubmit}
                        showTabs={true}
                    />

                    {!stepInfo.displayIntro && (
                        <React.Fragment>
                            <div className='box box-application'>
                                <div className='box-body'>
                                    <Step
                                        stepInfo={stepInfo}
                                        stepData={this.state.stepData}
                                        stepTooltip={this.state.stepTooltip}
                                        onStepSave={this.handleStepSave}
                                        onStepChange={this.handleStepChange}
                                        ref={c => (this._stepRef = c)}
                                    />
                                    <Navigator
                                        certificationSteps={this.state.certificationSteps}
                                        currentStepInfo={stepInfo}
                                        onStepNavigation={this.handleStepNavigation}
                                        onStepSave={this.handleStepSave}
                                        onStepCancel={this.handleStepCancel}
                                        onSubmit={this.handleSubmit}
                                        showTabs={false}
                                    />
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </ContentBody>
            </React.Fragment>
        );
    }
}

export default Certification;



// WEBPACK FOOTER //
// ./src/areas/certification/Certification.js